import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {CustomPasswordComponent} from '@app/shared/components/custom-password/custom-password.component';
import {EffectsModule} from '@ngrx/effects';
import {AbstractSecurityStorage, AuthModule, StsConfigLoader, StsConfigStaticLoader} from 'angular-auth-oidc-client';
import {SharedModule} from '../shared/shared.module';
import {AccountConfirmationComponent} from './components/account-confirmation/account-confirmation.component';
import {CallbackComponent} from './components/callback/callback.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';
import {InstitutionSettingsComponent} from './components/institution-settings/institution-settings.component';
import {LogoutComponent} from './components/logout/logout.component';
import {ProfileComponent} from './components/profile/profile.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {UnauthorizedComponent} from './components/unauthorized/unauthorized.component';
import {AuthConfigService} from './services/auth-config.service';
import {SecurityStorageService} from './services/security-storage.service';
import {AuthEffects} from './state/auth.effects';
import {InstitutionSettingsEffect} from './state/institution-settings.effect';

const authFactory = (configService: AuthConfigService) => {
  const config = configService.getConfig();
  return new StsConfigStaticLoader(config);
};

@NgModule({
  imports: [
    SharedModule,
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [AuthConfigService],
      },
    }),
    EffectsModule.forFeature([AuthEffects, InstitutionSettingsEffect]),
    CustomPasswordComponent,
    ReactiveFormsModule,
    LogoutComponent,
    UnauthorizedComponent,
    CallbackComponent,
    AccountConfirmationComponent,
    ResetPasswordComponent,
    ProfileComponent,
    ForgotPasswordComponent,
    InstitutionSettingsComponent,
  ],
  exports: [AuthModule],
  providers: [{provide: AbstractSecurityStorage, useClass: SecurityStorageService}],
})
export class AuthConfigModule {}
